import { ILandingContent, ILandingSection, SECTION_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { SectionAccordeon, SectionColumns, SectionDataFeed, SectionTabs, SectionVerticalTimeline } from "./section-design-type" 
import SectionCarousel from "./section-design-type/SectionCarousel"
import SectionHAccordeon from "./section-design-type/SectionHAccordeon"
import SectionHorizontalTimeline from "./section-design-type/SectionHorizontalTimeline"

/* Protopia Ecosystem component */
export interface IDataComponentsProps {
   section: ILandingSection,
   data: ILandingContent[]
}
const DataComponents = (props: IDataComponentsProps): JSX.Element => {
    const section = props.section  
    
    /* css class .landing-edit-cont - edit.select container for get bounds */
    
    if(!section.data) {
        return <></>
    }
    
    switch(section.designType) {
        case SECTION_DESIGN_TYPE.HACCORDEON:
            return <SectionHAccordeon {...props} /> 
        case SECTION_DESIGN_TYPE.VERTICAL_CAROUSEL:
        case SECTION_DESIGN_TYPE.CAROUSEL:
            return <SectionCarousel {...props} /> 
        case SECTION_DESIGN_TYPE.VERTICAL_TABS:
        case SECTION_DESIGN_TYPE.TABS:
            return <SectionTabs {...props} /> 
        case SECTION_DESIGN_TYPE.COLUMN: 
            return <SectionColumns {...props} /> 
        case SECTION_DESIGN_TYPE.ACCORDEON:
            return <SectionAccordeon {...props} /> 
        case SECTION_DESIGN_TYPE.VTIMELINE:
            return <SectionVerticalTimeline {...props} />
        case SECTION_DESIGN_TYPE.HTIMELINE:
            return <SectionHorizontalTimeline {...props} />
        case SECTION_DESIGN_TYPE.FEED:
        default:
            return <SectionDataFeed {...props} />
    }
}
export default DataComponents